import * as React from 'react';
import { Preloader } from '@cian/preloader-component';
import * as styles from './PublishTermsLoader.css';

interface IPublishTermsLoader {
  isMobile: boolean;
}

export const PublishTermsLoader = ({ isMobile }: IPublishTermsLoader) => {
  return (
    <div className={styles['wrapper']}>
      <Preloader size={isMobile ? 30 : 50} preloaderStyle={styles['loader']} />
    </div>
  );
};
